/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react/jsx-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';

import Select from 'react-select';
import IconSuccess from '../../../assets/images/brands/TestApiSuccess.png';
import IconFail from '../../../assets/images/brands/TestApiFail.png';

import {
  AddButton,
  Buttons,
  CancelButton,
  DeleteButton,
  UpdateButton,
} from '../../../components/Common/iComponents/iPopUp/IpopUp';
import { useSelector, useDispatch } from 'react-redux';

import {
  addSubApi,
  updateSubApi,
  deleteSubApi,
} from '../../../store/apiList/actions';

import { getClients } from '../../../store/client/actions';

import { IPopUp } from '../../../components/Common/iComponents/iPopUp/IpopUp';
import { ITable } from '../../../components/Common/iComponents/iTable/ITable';
import { IInput } from '../../../components/Common/iComponents/iInput/iInput';
import { ISwitch } from '../../../components/Common/iComponents/iSwitch/iSwitch';
import { ISelector } from '../../../components/Common/iComponents/iSelector/iSelector';

import { FormGroup, Label } from 'reactstrap';

import FormSubApis from './form-subApis';
import { testApiList, testApiListReset } from '../../../store/apiList/actions';
import { TestingButton } from '../../../components/Common/iComponents/iPopUp/IpopUp';

import { extractIdAndCleanText, changeNameLocation } from '../../../helpers/tools_helper';

const FormDetails = ({
  selectedRow,
  onCreate,
  onUpdate,
  onDelete,
  onCancel,
  adminFilters,
}: any) => {
  const [arrayUpdAdd, SetarrayUpdAdd] = useState<any>([]);

  const [columnsData, setColumnsData] = useState<any>([]);
  const [isAdmin, setIsAdmin] = useState<any>(false);

  const [popUpState, setpopUpState] = useState(false);
  const [selectedSubApiRow, setSelectedSubApiRow] = useState<any>([]);

  const [clientValid, setClientValid] = useState<any>(false);

  const columsPop = 2;
  const toggleField = 'enabled';
  const [form, setForm] = useState<any>({
    [toggleField]: false,
    identificator: '',
    name: '',
    host: '',
    wsdl: '',
    username: '',
    password: '',
    clientId: '',
    token: '',
    description: '',
    subApis: [],
  });
  const [flag, setflag] = useState<any>(true);
  const dispatch = useDispatch();
  const valuesSizeRolesPagination = [10, 20, 30, 40, 50, 100];
  const [paginationRoles, setPaginationRoles] = useState<any>({
    sizePerPage: valuesSizeRolesPagination[0],
    page: 1,
  });
  const [flagTesting, setflagTesting] = useState<any>(true);
  const [flagMagaya, setflagMagaya] = useState<any>(true);
  const { clients } = useSelector((state: any) => state.clients);
  const { testApi: testApiIcon, error } = useSelector(
    (state: any) => state.ApiList,
  );

  const identificator = ['Magaya', 'Chile_Express', 'SHOPIFY', 'MAGENTO 2', 'CIN7', 'E-ras'];

  const initialArrayTableClients = [
    {
      text: 'Id',
      dataField: 'id',
      formatter: (cellContent: any, clients: any) => <>{clients.id}</>,
      hidden: false,
    },
    {
      text: 'Name',
      dataField: 'name',
      formatter: (cellContent: any, clients: any) => <>{clients.name}</>,
      hidden: false,
    },
  ];

  const initialArrayTableSubClient = [
    {
      text: 'Entity',
      dataField: 'entityId',
      formatter: (cellContent: any, exampleSubclient: any) => (
        <>{exampleSubclient.entityId}</>
      ),
      hidden: false,
    },
    {
      text: 'Name',
      formatter: (cellContent: any, exampleSubclient: any) => (
        <>{exampleSubclient.iEntity.name}</>
      ),
      hidden: false,
    },
    {
      text: 'Host',
      dataField: 'host',
      formatter: (cellContent: any, exampleSubclient: any) => (
        <>{exampleSubclient.host}</>
      ),
      hidden: false,
    },
    {
      text: 'Token',
      dataField: 'token',
      formatter: (cellContent: any, exampleSubclient: any) => (
        <>{exampleSubclient.token}</>
      ),
      hidden: form.identificator === "CIN7" ? true : false,
    },
    {
      text: 'Location',
      dataField: 'location',
      formatter: (cellContent: any, exampleSubclient: any) => (
        <>{changeNameLocation(extractIdAndCleanText(exampleSubclient.location))}</>
      ),
    },
    {
      text: 'Token Account Id',
      dataField: 'tokenAccountId',
      formatter: (cellContent: any, exampleSubclient: any) => (
        <>{exampleSubclient.tokenAccountId}</>
      ),
      hidden: form.identificator === "CIN7" ? false : true,
    },
    {
      text: 'Token Application Key',
      dataField: 'tokenApplicationKey',
      formatter: (cellContent: any, exampleSubclient: any) => (
        <>{exampleSubclient.tokenApplicationKey}</>
      ),
      hidden: form.identificator === "CIN7" ? false : true,
    },
  ];

  useEffect(() => {
    if (form.identificator === '') {
      setColumnsData(['identificator']);
    } else {
      setColumnsData(arrayUpdAdd);
    }

    if (form.identificator === 'SHOPIFY' || form.identificator === 'MAGENTO 2' || form.identificator === 'CIN7') {
      const newArray = ['identificator', 'name', 'enabled'];
      if (isAdmin) newArray.splice(newArray.length - 1, 0, 'clientId');
      setColumnsData(newArray);
    }
  }, [form, arrayUpdAdd]);

  useEffect(() => {
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
      user = JSON.parse(getAuthUser);
    }
    if (user.ROL_ID !== '19') {
      if (!selectedRow) {
        setForm({ ...form, clientId: user.EMPRESA_ID });
      }
      setIsAdmin(false);
      if (form.identificator === 'E-ras') {
        SetarrayUpdAdd([
         'identificator',
          'name',
          'description',
          'username',
          'password',
          'enabled',
        ])
      } else {
        SetarrayUpdAdd([
          'identificator',
          'name',
          'host',
          'wsdl',
          'username',
          'password',
          'token',
          'description',
          'enabled',
        ]);
      }
    } else {
      setIsAdmin(true);
      if (form.identificator === 'E-ras') {
        SetarrayUpdAdd([
          'identificator',
          'name',
          'description',
          'username',
          'password',
          'clientId',
          'enabled',
        ])
      } else {
        SetarrayUpdAdd([
          'identificator',
          'name',
          'host',
          'wsdl',
          'username',
          'password',
          'clientId',
          'token',
          'description',
          'enabled',
        ]);
      }
    }
  }, [form.identificator]);

  useEffect(() => {
    if (selectedRow) {
      if (clients.length === 0) {
        dispatch(getClients({}));
      }

      const newArray = selectedRow.iSubApis?.map((item: any) => {
        return {
          ...item,
          entityId: item.entity_id,
        };
      });

      setForm({ ...selectedRow, subApis: newArray });
    }
  }, [selectedRow]);

  useEffect(() => {
    dispatch(getClients({}));
  }, []);

  useEffect(() => {
    dispatch(testApiListReset());
    if (String(form['clientId'])) {
      setClientValid(false);
    }
  }, [form]);

  useEffect(() => {
    const {
      identificator,
      name,
      host,
      wsdl,
      username,
      password,
      clientId,
      token,
    } = form;

    if (identificator != '' && name != '' && host != '' && clientId != '') {
      setflag(false);
    } else {
      setflag(true);
    }
    //--------------------------
    if (host != '' && wsdl != '' && username != '' && password != '') {
      setflagTesting(false);
    } else {
      setflagTesting(true);
    }
    //-----------------------------------
    if (
      identificator != '' &&
      name != '' &&
      host != '' &&
      wsdl != '' &&
      username != '' &&
      password != '' &&
      clientId != ''
    ) {
      if (form.identificator == 'Magaya') {
        if (testApiIcon === 'Success') {
          setflagMagaya(false);
        } else {
          return setflagMagaya(true);
        }
      }
    }
    //-----------------------------------
    if (identificator === 'SHOPIFY' || identificator === 'MAGENTO 2' || identificator === 'CIN7') {
      if (name != '' && clientId != '') {
        setflag(false);
      } else {
        setflag(true);
      }
    }
    if (identificator === 'E-ras') {
      if (username != '' && password != '') {
        setflag(false);
      } else {
        setflag(true);
      }
    }
  }, [form, testApiIcon]);

  useEffect(() => {
    if (!popUpState) setSelectedSubApiRow(undefined);
  }, [popUpState]);

  const handleDelete = (selectedSubApiRow: any) => {
    if (selectedSubApiRow?.id) {
      dispatch(deleteSubApi({ id: selectedSubApiRow?.id, adminFilters }));
      Swal.fire({
        icon: 'success',
        title: 'Added!!!',
        text: 'New items have been added successfully!!!',
      });
    } else {
      const newArray = [...form?.subApis];
      const index = newArray.indexOf(selectedSubApiRow);
      if (index !== -1) {
        newArray.splice(index, 1);
      }
      setForm({ ...form, subApis: newArray });
    }
    setpopUpState(false);
  };

  const handlePaginationRolesChange = (newState: any) => {
    setPaginationRoles(newState);
  };

  const handleAddAction = () => {
    if (String(form['clientId'])) {
      setpopUpState(!popUpState);
      setClientValid(false);
    } else {
      setClientValid(true);
    }
  };

  const onPopUpState = () => {
    setpopUpState(!popUpState);
  };

  const handleActionOnRowClick = (row: any) => {
    setSelectedSubApiRow(row);
  };

  const handlesetpopUpState = (state: any) => {
    setpopUpState(state);
  };

  const itemVals = (val: any, updateVal: any) => {
    for (const property in updateVal) {
      if (property === val) {
        return updateVal[property];
      }
    }
  };

  const renderButtons = () => (
    <Buttons>
      {selectedRow ? (
        <>
          <CancelButton
            className="button"
            onClick={() => onCancel()}
            data-bs-toggle="tooltip"
          >
            <i
              className="bx bx-power-off"
              style={{ fontSize: '2.5em' }}
              data-bs-toggle="tooltip"
            ></i>
          </CancelButton>
          <DeleteButton
            type="button"
            className="btn-delete"
            onClick={() => onDelete(selectedRow.id)}
          >
            <i className="dripicons-trash" style={{ fontSize: '1.7em' }}></i>
          </DeleteButton>
          <UpdateButton
            className="button"
            disabled={form.identificator !== 'Magaya' ? flag : flagMagaya}
            onClick={() => onUpdate(form)}
          >
            <i className="bx bx-sync" style={{ fontSize: '2.5em' }}></i>
          </UpdateButton>
        </>
      ) : (
        <AddButton
          type="submit"
          disabled={flag}
          className="btn"
          onClick={() => onCreate(form)}
        >
          <i className="bx bx-plus" style={{ fontSize: '3em' }} />
        </AddButton>
      )}
      {form.identificator === 'Magaya' ? (
        <TestingButton
          className="button"
          disabled={flagTesting}
          onClick={() => dispatch(testApiList(form))}
        >
          <i className="dripicons-wifi" style={{ fontSize: '2em' }} />
        </TestingButton>
      ) : null}
    </Buttons>
  );

  const onChangeBooleanHandler = (e: any, n: any) => {
    setForm({
      ...form,
      [n]: !form[n as keyof typeof form],
    });
  };

  const onChangeHandler = (e: any, n: any) => {
    setForm({
      ...form,
      [n]: e.target.value,
    });
  };

  const onChangeSelectorHandler = (n: any, value: any) => {
    setForm({
      ...form,
      [n]: String(value.id),
    });
  };

  const handleCreate = (data: any) => {
    if (selectedRow?.id) {
      setpopUpState(!popUpState);
      dispatch(
        addSubApi({ data: { ...data, apiId: selectedRow?.id }, adminFilters }),
      );
      Swal.fire({
        icon: 'success',
        title: 'Added!!!',
        text: 'New items have been added successfully!!!',
      });
    } else {
      const newArray = [...form.subApis];
      newArray.push({ ...data, uuid: Math.random() * 5000 });
      setForm({ ...form, subApis: newArray });
    }

    setpopUpState(!popUpState);
  };

  const handleUpdate = (data: any) => {
    if (data?.id) {
      dispatch(
        updateSubApi({
          data: { ...data, apiId: selectedRow?.id },
          adminFilters,
        }),
      );
      Swal.fire({
        icon: 'success',
        title: 'Updated!!!',
        text: 'New items have been updated successfully!!!',
      });
    } else {
      const newArray = [...form?.subApis];
      const index = newArray.findIndex((item) => item.uuid == data.uuid);
      newArray[index] = { ...data };
      setForm({ ...form, subApis: newArray });
    }
    setpopUpState(false);
  };

  const handleCancel = (id: any) => {
    setpopUpState(!popUpState);
  };

  const handleSubApiCreate = (data: any) => { };

  return (
    <div
      className={form['identificator'] ? '' : 'pt-5  d-flex'}
      style={{ width: '700px', height: '550px' }}
    >
      <div
        className={'row col-12 pt-3 w-100 pe-5'}
        style={{
          marginLeft: '4%',
          marginRight: '10%',
          paddingTop: '0.5%',
        }}
      >
        {columnsData?.map((val: any) => {
          const nameObject = val as keyof typeof form;
          const temp = form[nameObject];
          const valid = temp ? true : false;
          let type = '';
          let nameSelector = '';
          const value = selectedRow ? itemVals(val, selectedRow) : null;

          if (value) identificator.push('Select identificator');

          switch (val) {
            case 'identificator':
              return (
                <div className="col-12 pb-3">
                  <Select
                    defaultValue={{ label: value ?? 'Select Identificator' }}
                    onChange={(e: any) => setForm({ ...form, [val]: e.label })}
                    options={identificator.map((item: any) => {
                      return { label: item, value: item };
                    })}
                    classNamePrefix="select2-selection"
                  />
                </div>
              );
            case 'clientId':
              nameSelector =
                value || value === null
                  ? clients.filter(
                    (item: any) => Number(item.id) === Number(temp),
                  )[0]?.name
                  : '';
              return (
                <div className="col-6 pb-2">
                  <ISelector
                    style={clientValid ? { border: 'solid 3px red' } : {}}
                    title={val}
                    value={String(temp)}
                    nameSelector={nameSelector ?? ''}
                    valuesSizePagination={valuesSizeRolesPagination}
                    dataSelector={clients}
                    CountItems={'10'}
                    initialArrayTable={initialArrayTableClients}
                    handlePaginationChange={handlePaginationRolesChange}
                    setSelectedRow={onChangeSelectorHandler}
                    onChangeHandler={onChangeHandler}
                  />
                </div>
              );

            case 'enabled':
              return (
                <div className="col-6 pb-2">
                  <FormGroup className="text-center">
                    <div className="text-capitalize">
                      <Label>{val.replace(/_/g, ' ').toLowerCase()}</Label>
                    </div>
                    <Label>
                      <ISwitch
                        title={val}
                        checked={Boolean(form[nameObject])}
                        onChangeBooleanHandler={onChangeBooleanHandler}
                      />
                    </Label>
                  </FormGroup>
                </div>
              );
            default:
              type = 'text';
              break;
          }
          return (
            <div className="col-6 pb-2">
              <IInput
                name={form.identificator === "E-ras" ? val.replace("username", "Client Id (E-ras)*").replace("password", "Client Secret (E-ras)*") : val}
                title={val}
                valid={valid}
                value={value}
                type={type}
                onChangeHandler={onChangeHandler}
              />
            </div>
          );
        })}

        {form['identificator'] === 'SHOPIFY' || form['identificator'] === 'MAGENTO 2' || form['identificator'] === 'CIN7' ? (
          <>
            <div className="col-6 d-flex justify-content-end pt-3 h-50 pe-3">
              <button
                type="button"
                className="btn bg-primary text-white add-primary-button"
                onClick={handleAddAction}
              >
                + Add
              </button>
            </div>

            {form?.subApis?.length === 0 ? null : (
              <div className="col-12" style={{ height: 230, overflow: 'auto' }}>
                <ITable
                  enableDownload={false}
                  data={form.subApis}
                  fields={initialArrayTableSubClient}
                  tableColumns={initialArrayTableSubClient}
                  pagSize={4}
                  pageStartIn={0}
                  showTotal={true}
                  disablePageTitle={true}
                  headerColorT={'bg-primary text-white'}
                  tableViewList={initialArrayTableSubClient}
                  handlePopUpState={onPopUpState}
                  actionOnRowClick={handleActionOnRowClick}
                />
              </div>
            )}
          </>
        ) : null}
      </div>
      {form['identificator'] ? (
        <div
          className={
            (form?.subApis?.length === 0 ? 'mt-4' : '') +
            ' pe-2 d-flex justify-content-end'
          }
        >
          {form.identificator === 'Magaya' && testApiIcon != '' ? (
            <div style={{ margin: '0 auto 0 15px' }}>
              <img
                style={{ width: '100px' }}
                alt={`Connection ${testApiIcon}`}
                src={testApiIcon === 'Success' ? IconSuccess : IconFail}
              />
              {testApiIcon != 'Success' ? <p>{error}</p> : null}
            </div>
          ) : null}
          {renderButtons()}
        </div>
      ) : null}
      <IPopUp
        stateAdd={popUpState}
        switchStateAdd={handlesetpopUpState}
        modalTitleAdd={'SubClient'}
        icon="code"
        colorHeaderPop={'#101340'}
      >
        <FormSubApis
          apiId={selectedRow?.id}
          selectedRow={selectedSubApiRow}
          onCreate={handleCreate}
          onUpdate={handleUpdate}
          onDelete={handleDelete}
          onCancel={handleCancel}
          SubApiCreate={handleSubApiCreate}
          clientId={String(form['clientId'])}
          identificator={form.identificator}
        />
      </IPopUp>
    </div>
  );
};

FormDetails.propTypes = {
  selectedRow: PropTypes.object,
  onCreate: PropTypes.func,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
  onCancel: PropTypes.func,
  adminFilters: PropTypes.string,
};

export default FormDetails;
